import { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import Loader from '../Loader'
import { ROUTES } from 'routes/paths'
import SessionError from 'pages/SessionError'
const SessionErrorRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route component={SessionError} exact path={ROUTES.SESSION_ERROR} />
      </Switch>
    </Suspense>
  )
}

export default SessionErrorRoutes
